import { useEffect } from 'react';

import { useIdleSignOut } from '../hooks/use-idle-sign-out';
import { useAuthStore } from '../store/auth.store';

/**
 * Restores the persisted session on first paint.
 *
 * Wiring the HTTP client is deliberately NOT done here — see
 * `api/configure-auth.ts`, which runs at startup from `main.tsx`. This
 * component's only job is the one thing that genuinely belongs to the React
 * lifecycle: moving the store out of its `restoring` state once storage has
 * been read, so the route guards know whether to render or redirect — and
 * running the idle sign-out while a session is open.
 */
export function AuthProvider({ children }: { children: React.ReactNode }) {
  const restore = useAuthStore((state) => state.restore);

  useEffect(() => {
    restore();
  }, [restore]);

  useIdleSignOut();

  return children;
}
